import { DisplayConfig, Level } from './display.config';

export const defaultDisplayConfig: DisplayConfig = {
  displayLevel: Level.NONE,
};

export const devDisplayConfig: DisplayConfig = {
  displayLevel: Level.CONSOLE,
};
